// Suomen Vahvimmat certificate (Asiakastieto), order #484859.
// Assets source: sertifikaattituotteet_484859_18948071841781557200000/ (not committed).

export const suomenVahvimmatConfig = {
  profileUrl: 'https://www.asiakastieto.fi/yritykset/fi/-/34224678/yleiskuva',
  guideUrl: 'https://www.asiakastieto.fi/web/fi/ohjeet-sertifikaatin-kayttoonottoon',
  certifiedYear: 2026,
} as const;
